import { getModels } from "@/lib/data";

export async function GET() {
  const models = await getModels();
  return Response.json(models);
}
